import React, { useRef } from "react"
import { useInView } from "framer-motion"

import { Container } from "../Container"
import ContentfulLongText from "../ContentfulLongText"
import GreenLogo from "../../images/favicon_2.jpg"
import StripesBg from "../../images/service-inquiry-bg.png"

import "./index.css"

const ServiceLists = ({ queueLists }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    return (
        <div ref={ref} className="flex wrap service--lists">
            {queueLists?.map((item, index) => (
                <div 
                    key={index} 
                    className="relative service--item"
                    style={{
                        transform: isInView ? "none" : `translateX(-${50 + index}px)`,
                        opacity: isInView ? 1 : 0,
                        transition: `all ${.9 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.9 * index}s`,
                    }}
                >
                    <div style={{ background: `url(${StripesBg})`}} className="absolute top-0 left-0 right-0 bottom-0 z-index--1 service--item-bg"></div>
                    <h5 className="mt-0 mb-0 service--item-title"><span>{item.title}</span></h5>
                    <div className="service--item-lists">
                        {item?.buttonConfig && 
                            item?.buttonConfig.map((list, identifier) => {
                                console.log(list)
                                if(list.buttonLink !== null) {
                                    return (
                                        <a 
                                            key={identifier} 
                                            href={list.buttonLink} 
                                            rel={item.isNoFollow ? 'nofollow noopener noreferrer':''} 
                                            // target={item.openInNewTab ? '_blank' : '_self'}
                                            className="relative z-2 block mt-0 mb-0 text--dark decoration-none"
                                        >{list.buttonName}</a>
                                    )
                                } else {
                                    return (
                                        <div 
                                            key={identifier}
                                            className="relative z-2 block mt-0 mb-0 text--dark decoration-none"
                                        >{list.buttonName}</div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            ))}
        </div>
    )
}

const ServiceInquiry = ({ content, serviceInquiryQueue }) => {
    return (
        <div className="component-service-inquiry">
            <Container>
                {content.servicesInquiryTitle && <h3 className="mb-0 uppercase text-center"><img src={GreenLogo} className="mb-0" alt="Savor Brands" />{content.servicesInquiryTitle}</h3>}
                {content.servicesInquiryDescription && <ContentfulLongText longTextContent={content.servicesInquiryDescription.servicesInquiryDescription} classNameProp="text-center" />}
                {serviceInquiryQueue && <ServiceLists queueLists={serviceInquiryQueue} />}
            </Container>
        </div>
    )
}

export default ServiceInquiry